class P2PMessage {
}

export { P2PMessage };
//# sourceMappingURL=P2PMessage.js.map
